'use client'

import type { ServerConfig } from './types'
import type { ReactNode } from 'react'
import React, { useContext } from 'react'

const ServerConfigContext = React.createContext<ServerConfig | null>(null)

interface ServerConfigProviderProps {
  config: ServerConfig
  children: ReactNode
}

export function ServerConfigProvider({
  config,
  children,
}: ServerConfigProviderProps) {
  return (
    <ServerConfigContext.Provider value={config}>
      {children}
    </ServerConfigContext.Provider>
  )
}

export function useServerConfig(): ServerConfig {
  const context = useContext(ServerConfigContext)
  if (!context) {
    throw new Error(
      'useServerConfig must be used within a ServerConfigProvider',
    )
  }
  return context
}

export function usePostHogConfig() {
  const config = useServerConfig()
  return config.posthog
}
